<article class="base-pages" [class.desktop]="deviceService?.isDesktop()">
  <a *ngFor="let page of basePagesList; trackBy: trackByFn"
     [queryParams]="{currency: getMyCurrency}"
     [routerLink]="url(page)?.path"
     [attr.disabled]="isDisabled(page) ? 'disabled' : null"
     class="item-link"
     [class.disabled]="isDisabled(page)">

    <ng-template [ngIf]="isBrowser" [ngIfElse]="noBrowser">
      <div class="icon" [lazyLoad]="assetsUrl('/assets/images/library/' + page + '.jpg')"></div>
    </ng-template>
    <ng-template #noBrowser>
      <div class="icon" [style.background-image]="'url(' + assetsUrl('/assets/images/library/' + page + '.jpg') + ')'"></div>
    </ng-template>

    <span class="label bold">{{ ('library.base-pages.' + page) | customLocale }}</span>
  </a>
</article>
